import React, { PureComponent } from 'react';
import moment from 'moment';
// import { url } from './../url';
import './App.scss';
import { withLocalize } from 'react-localize-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Headers from './layout/header';
import LeftMenu from './layout/nav';
import Login from '../containers/auth/login';
import { renderToStaticMarkup } from 'react-dom/server';
import { getCookie } from '../common/enum';
import Register from '../containers/auth/register';
import Container from '../components/Container';

import ForgotPassword from '../containers/auth/forgot-password';

// import PageError from './auth/page-error';
import Dashboard from '../containers/user/dashboard/dashboard';
import DashboardTeam from '../containers/user/dashboard/dashboard-team';
import DashboardTopic from '../containers/user/dashboard/dashboard-topic';

import AdminDelivery from '../containers/user/admin-delivery';
// import MatchSchedule from './team/team-report/fixed-report/match-schedule/match-schedule';
import AdminNews from '../containers/user/admin-news/index';
import OptionAdminNews from '../containers/user/admin-news/add-edit/index';
import AdminUser from '../containers/user/admin-user/index';
import Team from '../containers/user/team/index';
import AdminUserList from '../containers/user/admin-user-list';
import AdminCompany from '../containers/user/admin-company';
import LeaderBoard from '../containers/user/leader-board';
import Player from '../containers/user/player';
import MyTopic from '../containers/user/my-topic';
import Game from '../containers/user/game';
import PlaylogSearch from '../containers/user/playlog-search';
import Delivery from '../containers/user/delivery';
import News from '../containers/user/news';
import Recommend from '../containers/user/recommend';
import Live from '../containers/user/live';
import {LiveDetail} from '../containers/user/live/LiveDetail';
import pageError from '../containers/auth/page-error';

import DetailedDearch from '../containers/user/detailed-dearch';
import 'moment/locale/ja';

moment.locale('ja');

// eslint-disable-next-line react/prop-types
const CheckLogin = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <Component {...props} />
        )}
    />
);

// eslint-disable-next-line react/prop-types
const PrivateRoute = ({ component: Component, ...rest }) => (
    localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN') ?
        <Route
            {...rest}
            render={(props) => (
                <Component {...props} />
            )}
        /> : <Redirect to={{ pathname: '/login' }} />
);

class App extends PureComponent {
    constructor(props) {
        super(props);
        const { addTranslationForLanguage: addLanguage } = this.props;
        this.props.initialize({
            languages: [
                { name: "English", code: 'en' },
                { name: "Japan", code: 'ja' }
            ],
            options: {
                defaultLanguage: 'ja',
                renderToStaticMarkup
            }
        });
        addLanguage(require('../translations/en/en.json'), 'en');
        addLanguage(require('../translations/jp/jp.json'), 'ja');
    }

    render() {
        return (
            <Router>
                <div className="App">
                    <div className="app-left-menu no-print">
                        <Route component={LeftMenu} />
                    </div>
                    <div className="app-main print" id="app-main">
                        <div className="app-main-header no-print">
                            <Route component={Headers} />
                        </div>
                        <div className="app-main-content">
                            <Container>
                            <Switch>
                                <CheckLogin path="/login" exact component={Login} />
                                <PrivateRoute path="/dashboard" exact component={Dashboard} />
                                <PrivateRoute path="/dashboard-team" exact component={DashboardTeam} />
                                <PrivateRoute path="/dashboard-team?team=:id" exact component={DashboardTeam} />
                                <PrivateRoute path="/dashboard-topic" exact component={DashboardTopic} />
                                <PrivateRoute path="/admin-delivery" exact component={AdminDelivery} />
                                <PrivateRoute path="/delivery" exact component={Delivery} />
                                <PrivateRoute path="/admin-news" exact component={AdminNews} />
                                <PrivateRoute path="/admin-news/add" exact component={OptionAdminNews} />
                                <PrivateRoute path="/admin-news/edit" exact component={OptionAdminNews} />
                                <PrivateRoute path="/admin-user" exact component={AdminUser} />
                                <PrivateRoute path="/admin-company" exact component={AdminCompany} />
                                <PrivateRoute path="/admin-list-user" exact component={AdminUserList} />
                                <PrivateRoute path="/admin-list-user/groups/:id/:name" exact component={AdminUserList} />
                                <PrivateRoute path="/leader-board" exact component={LeaderBoard} />
                                <PrivateRoute path="/my-topic" exact component={MyTopic} />
                                <PrivateRoute path="/game" exact component={Game} />
                                <PrivateRoute path="/game/:id/:teamId/:day" component={Game} />
                                <PrivateRoute path="/register" exact component={Register} />
                                <PrivateRoute path="/forgot-pass" exact component={ForgotPassword} />
                                <PrivateRoute path="/team-report/:id" component={Team} />
                                <PrivateRoute path="/live" exact component={Live} />
                                <PrivateRoute path="/live/:game_id" exact component={LiveDetail} />
                                {/* <PrivateRoute path="/player/:id" component={Player} /> */}
                                <PrivateRoute path="/player/:id" component={(props) => {
                                    const {
                                    match: {
                                        params: { id }
                                    }} = props;
                                    return <Player {...props} key={`playerId-${id}`}/>
                                }} />
                                <PrivateRoute path="/playlog-search" component={PlaylogSearch} />
                                <PrivateRoute path="/detailed-search" component={DetailedDearch} />
                                <PrivateRoute path="/news" component={News} />
                                <PrivateRoute path="/recommend" component={Recommend} />
                                <PrivateRoute path="/" exact component={Login} />
                                <PrivateRoute path="*" exact component={pageError} />
                            </Switch>
                            </Container>
                        </div>
                    </div>
                </div>
            </Router>
        );
    }
}

export default withLocalize(App);
